"use client";

import { useEffect, useState } from "react";
import LandingPageContent from "./LandingPageContent";
import MobileLandingPageContent from "./mobile/MobileLandingPageContent";

export default function LandingPageWrapper() {
	const [isMobile, setIsMobile] = useState<boolean>(false);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		// Client-side mobile detection after mount
		const checkMobile = () => {
			setIsMobile(
				window.innerWidth < 768 ||
					/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
						navigator.userAgent
					)
			);
		};

		setMounted(true);
		checkMobile();

		// Listen for resize events
		const handleResize = () => {
			checkMobile();
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	// Always render desktop version initially to prevent hydration mismatch
	// Server and client will both render the same thing initially
	// Then switch to mobile if needed after hydration
	if (!mounted) {
		return <LandingPageContent />;
	}

	return isMobile ? <MobileLandingPageContent /> : <LandingPageContent />;
}
